module.exports = "/_next/static/images/8cf0cb0db275ff35a8dc92e896aef353-boy-looking-to-the-front@0.5x.jpg";